var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 324,
    viewBox: "0 0 393 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393 106.716V0L0 324H393V106.716Z",
    fill: "#FEF3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRectangle);
export default __webpack_public_path__ + "static/media/small-rectangle.530874bd1e20b994df12b2ca655a6dd0.svg";
export { ForwardRef as ReactComponent };